/**
 * UI elements
 */
 class SW_UI {
  constructor() {
    this.initSmoothScroll();
    this.initStyledSelect();
    this.initOpenSearchForm();
    this.initYTVideoWithCover();
    this.initBackgroundOnScroll();
    this.initOpenOptions();
  }

  initSmoothScroll () {
    $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - 300
          }, 1000);
        }
      }
    });
  }

  initStyledSelect () {
    if (!$('select').length) {
      return
    }

    window.easydropdown.all();
  }

  initOpenSearchForm () {
    let openSearchIcon = $('.search-form .icon');
    let searchForm = $('.search-form');

    if (!openSearchIcon.length) {
      return
    }

    openSearchIcon.on('click', () => {
      searchForm.toggleClass('is-active');
    });
  }

  initYTVideoWithCover () {
    let videos = $('.video-wrapper .cover');
    
    if (!videos.length) {
      return;
    }

    for (let i = 0; i < videos.length; i++) {
      let overlay = videos.eq(i);

      videos.eq(i).on('click', e => {
        e.preventDefault();
        overlay.addClass('is-hidden');
        overlay.parents('.video-wrapper').addClass('is-active');
        let iframe = overlay.parent().find('iframe');
        let videoElement = overlay.parent().find('video');

        if (iframe.length) {
          iframe[0].contentWindow.postMessage(JSON.stringify({
            'event': 'command',
            'func': 'playVideo',
            'args': []
          }), '*');
        }

        if (videoElement.length) {
          let allVideos = $('video');

          for (let i = 0; i < allVideos.length; i++) {
            allVideos[i].pause();
          }
          
          videoElement[0].play();
        }
      });
    }
  }

  initBackgroundOnScroll () {
    let imageWrapper = $('.image-bg-wrapper');

    if (!imageWrapper.length) {
      return;
    }

    let images = imageWrapper.find('.image');

    let breakpoints = {
      why: $("#dlaczego-my").position().top,
      smartWorkout: $("#smart-workout").position().top,
      creativeWork: $("#creative-work").position().top,
      smartGift: $("#smart-gift").position().top,
      smartCoach: $("#smart-coach").position().top,
      contact: $("#contact-block").position().top
    };

    let creativeWorkSection = $('.section-on-bg.section-creative-work');

    $(window).on('resize', () => {
      breakpoints = {
        why: $("#dlaczego-my").position().top,
        smartWorkout: $("#smart-workout").position().top,
        creativeWork: $("#creative-work").position().top,
        smartGift: $("#smart-gift").position().top,
        smartCoach: $("#smart-coach").position().top,
        contact: $("#contact-block").position().top
      };  
    });

    for(let i = 0; i < images.length; i++) {
      $(window).on("scroll touchmove", function() {
        let scrollY = $(document).scrollTop();
        
        if (scrollY < breakpoints.why - 500) {
          images.removeClass('active');
          images.eq(0).addClass('active');
          creativeWorkSection.removeClass('active');
          return;
        }
        
        if ((scrollY >= breakpoints.why - 500) && scrollY < breakpoints.smartWorkout - 500) {
          images.removeClass('active');
          images.eq(0).addClass('active');
          creativeWorkSection.removeClass('active');
          return;
        };

        if ((scrollY >= breakpoints.smartWorkout - 500) && (scrollY < breakpoints.creativeWork - 500)) {
          images.removeClass('active');
          images.eq(1).addClass('active');
          creativeWorkSection.removeClass('active');
          return;
        };

        if ((scrollY >= breakpoints.creativeWork - 500) && (scrollY < breakpoints.smartGift - 500)) {
          images.removeClass('active');
          images.eq(2).addClass('active');
          creativeWorkSection.addClass('active');
          return;
        };

        if ((scrollY >= breakpoints.smartGift - 500) && (scrollY < breakpoints.smartCoach - 500)) {
          images.removeClass('active');
          images.eq(3).addClass('active');
          creativeWorkSection.removeClass('active');
          return;
        };

        if ((scrollY >= breakpoints.smartCoach - 500) && (scrollY < breakpoints.contact - 500)) {
          images.removeClass('active');
          images.eq(4).addClass('active');
          creativeWorkSection.removeClass('active');
          return;
        };

        if (scrollY >= breakpoints.contact) {
          images.removeClass('active');
          images.eq(5).addClass('active');
          creativeWorkSection.removeClass('active');
        };
      });
    }
  }

  initOpenOptions () {
    let openOptionsBtn = $('.open-options');
    
    if (!openOptionsBtn.length) {
      return
    }

    for (let i = 0; i < openOptionsBtn.length; i++) {
      let options = openOptionsBtn.eq(i).parent().find('.user_list__manage');

      openOptionsBtn.eq(i).on('click', (e) => {
        e.preventDefault();
        options.toggleClass('active');
      });
    }
  }
}